import React from 'react'
import { Formik } from 'formik'
import { connect } from 'react-redux'
import styled, { withTheme } from 'styled-components'
import AppointmentMultipleFilters from '../../../../components/form/appointmentMultipleFilters'
import AppointmentSearchFilters from '../../../../components/form/appointmentSearchFilters'
import { Title } from '../../../../components/ui/text'
import { useAppointmentFilterHandlers } from '../../../../hooks/useAppointmentFilterHandlers'
import fonts from '../../../../styled/fonts'
import { BOOKING_TYPES } from '../constants'
import { validationsInitialForm, validationsMultipleAppointments } from '../schemas/initialFormSchemas'
import { BackPageHeader } from '../../../../components/ui/header'
import useIsMobile from '../../../../hooks/useIsMobile'
const { fontWeight } = fonts

const Container = styled.div`
	max-width: 740px;
	display: flex;
	flex-direction: column;
	width: 100%;
	gap:13px;
	
	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		width: 100%;
		display: flex;
		flex-direction: column;
		flex: 1;
	}
`

const FormContent = styled.div`
	width: 100%;
	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		display: flex;
		flex-direction: column;
		flex: 1;
		height: 100%;
		min-height: 0;
	}
`

const InitialForm = ({
	onNext,
	onUpdateFormData,
	formData,
	bookingType,
	clinics,
	specialties,
	professionals,
	professionalsKey,
	getProfessionals,
	theme,
	onBack
}) => {
	const isMobile = useIsMobile()
	const currentBookingType = bookingType || BOOKING_TYPES.SINGLE
	const titleText =
		currentBookingType === BOOKING_TYPES.SINGLE
			? 'Programá tu turno presencial'
			: 'Programá tus turnos presenciales'
	const validationSchema =
		currentBookingType === BOOKING_TYPES.MULTIPLE
			? validationsMultipleAppointments
			: validationsInitialForm

	const {
		loadedProfessionalsKey,
		onChangeSpeciality,
		onChangeClinic,
		getProfessionalsKey,
		getClinicOptions
	} = useAppointmentFilterHandlers({
		clinics,
		professionals,
		getProfessionals,
		initialLoadedKey: professionalsKey,
		onSpecialityChange: payload => onUpdateFormData && onUpdateFormData(payload),
		onClinicChange: payload => onUpdateFormData && onUpdateFormData(payload)
	})

	const handleFormSubmit = values => {
		onNext(values)
	}

	return (
		<Container>
			<BackPageHeader onBack={onBack} showBack={!isMobile} title={titleText} />

			<Formik
				initialValues={formData}
				validationSchema={validationSchema}
				onSubmit={handleFormSubmit}
				validateOnChange
				validateOnBlur
			>
				{({ values, errors, touched, handleSubmit, setFieldValue }) => {
					const currentProfessionalsKey = getProfessionalsKey(values.speciality, values.clinicCode)
					const professionalOptions =
						loadedProfessionalsKey === currentProfessionalsKey ? professionals : []

					return (
						<FormContent>
							{currentBookingType === BOOKING_TYPES.SINGLE ? (
								<AppointmentSearchFilters
									values={values}
									errors={errors}
									touched={touched}
									handleSubmit={handleSubmit}
									setFieldValue={setFieldValue}
									specialties={specialties}
									clinics={clinics}
									professionalOptions={professionalOptions}
									onChangeSpeciality={onChangeSpeciality}
									onChangeClinic={onChangeClinic}
									getClinicOptions={getClinicOptions}
								/>
							) : (
								<AppointmentMultipleFilters
									values={values}
									errors={errors}
									touched={touched}
									handleSubmit={handleSubmit}
									setFieldValue={setFieldValue}
									specialties={specialties}
									clinics={clinics}
									professionalOptions={professionalOptions}
									onChangeSpeciality={onChangeSpeciality}
									onChangeClinic={onChangeClinic}
									getClinicOptions={getClinicOptions}
								/>
							)}
						</FormContent>
					)
				}}
			</Formik>
		</Container>
	)
}

function mapStateToProps({ appointment }) {
	return {
		formData: appointment.booking.formData,
		clinics: appointment.booking.catalogs.clinics,
		specialties: appointment.booking.catalogs.specialties,
		professionals: appointment.booking.catalogs.professionals,
		professionalsKey: appointment.booking.catalogs.professionalsKey,
		bookingType: appointment.booking.mode
	}
}

export default connect(mapStateToProps)(withTheme(InitialForm))
